import { images } from '../constants';

const home = [
    {
        "id": 1,
        "image": images.home1,
        "title": "Servicios en baja tensión",
        "content": "Ofrecemos soluciones seguras y eficientes en sistemas eléctricos de baja tensión (menos de 1,000 V). Realizamos instalaciones, mantenimientos y reparaciones, asegurando un funcionamiento óptimo y cumpliendo con todas las normativas. Garantizamos calidad y seguridad en cada proyecto."
    },
    {
        "id": 2,
        "image": images.home2,
        "title": "Servicios de Media Tensión",
        "content": "Brindamos soluciones especializadas en la instalación, mantenimiento y reparación de sistemas eléctricos de media tensión (1,000 a 36,000 V). Garantizamos seguridad, eficiencia y cumplimiento de normativas, con un equipo altamente capacitado para asegurar un servicio confiable y adaptado a las necesidades de cada proyecto."
    },
    {
        "id": 3,
        "image": images.home3,
        "title": "Servicios de Instrumentación y Control Industrial",
        "content": "Optimizamos la eficiencia y seguridad de tus procesos industriales con sistemas de control y monitoreo, asegurando instalación y mantenimiento precisos adaptados a cada proyecto."
    },
    {
        "id": 4,
        "image": images.home4,
        "title": "Mantención de grupos electrógenos",
        "content": "Instalamos y mantenemos grupos electrógenos para asegurar un suministro eléctrico confiable. Nuestro equipo experto garantiza instalaciones seguras y un mantenimiento que maximiza el rendimiento y la durabilidad."
    },
    {
        "id": 5,
        "image": images.home5,
        "title": "Mantención de bombas de aguas (Fluidos varios)",
        "content": "Brindamos montaje y mantenimiento de bombas para agua potable, aguas servidas y fluidos diversos, asegurando un funcionamiento eficiente y prolongando la vida útil de tus equipos."
    },
    {
        "id": 6,
        "image": images.home6,
        "title": "Desarrollo de proyectos de eficiencia energética",
        "content": "Proporcionamos soluciones personalizadas de energía solar y eólica que optimizan el consumo energético y reducen costos, promoviendo un futuro más sostenible y económico para tu familia o negocio."
    }
];


export default home;
